module.exports = __webpack_public_path__ + "img/analytics.d0df52ca.png";